import { render, staticRenderFns } from "./OfertaEdit.vue?vue&type=template&id=453b3b49&scoped=true&"
import script from "./OfertaEdit.vue?vue&type=script&lang=js&"
export * from "./OfertaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453b3b49",
  null
  
)

export default component.exports